import { defineStore } from 'pinia'
import state from '@/stores/dialogs/state'
import actionsStore from '@/stores/dialogs/actions'
import gettersStore from '@/stores/dialogs/getters'
import mutationsStore from '@/stores/dialogs/mutations'

export const useDialogsStore = defineStore('dialogs', () => {
  const getters = gettersStore(state)
  const mutations = mutationsStore(state)
  const actions = actionsStore(state, mutations)
  return {
    state,
    getters,
    mutations,
    actions,
  }
})
